import * as React from "react";
import useTelemetry from "../../utils/Telemetry/useTelemetry";

export const L2Container = () => {
  const telemetry = useTelemetry();
  React.useEffect(() => {
    telemetry.sendPageInitEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div id="l2-page"></div>;
};
